import React, { useState } from 'react'
import SideNav from './SideNav'

const SideNavIcon = () => {
  const [isNavOpen, setIsNavOpen] = useState(false)

  return (
    <>
      <i onClick={() => setIsNavOpen(true)} className="iconfont iconkxian-xianshishezhi f14 c7"></i>

      <SideNav isOpen={isNavOpen} onClose={() => setIsNavOpen(false)} />
    </>
  )
}

export default SideNavIcon
